import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineClientContactCompletePage } from '@/feature/hotline/client/detail/contact/complete/page/HotlineClientContactCompletePage';
/**
 * 匿名ホットライン今後の進め方 完了
 */
export const HotlineClientContactComplete = () => (_jsx(HotlineClientContactCompletePage, {}));
